var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "greyed-out" },
    [
      _c(
        "b-row",
        { staticClass: "h-100 justify-content-center align-items-center" },
        [
          _c(
            "b-col",
            { staticClass: "text-center", attrs: { cols: "10", sm: "6" } },
            [
              _c("i", {
                staticClass: "fa fa-2x fa-circle ld ld-bounce-ltr text-primary",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(" "),
              _c("h1", { staticClass: "main-title" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t("account.verification.settingUpYourAccount")
                    ) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "description" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("account.verification.goGrabCookies")) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c(
                "router-link",
                {
                  staticClass:
                    "btn-moregage-login btn-primary centered btn white-text",
                  attrs: { to: "login" },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("global.actions.backToLogin")) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }